import { Layout, Typography, List } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Cookies = () => {
  const cookieTypes = [
    {
      title: "Notwendige Cookies",
      description:
        "Diese Cookies sind für die Grundfunktionen der Website erforderlich. Sie ermöglichen die Navigation und die Nutzung der Webseite. Ohne diese Cookies können wesentliche Teile unserer Webseite nicht richtig funktionieren.",
    },
    {
      title: "Funktionale Cookies",
      description:
        "Diese Cookies ermöglichen es uns, erweiterte Funktionalitäten und Personalisierung bereitzustellen. Sie können von uns oder von Drittanbietern gesetzt werden, deren Dienste wir auf unseren Seiten verwenden.",
    },
    {
      title: "Analyse-Cookies",
      description:
        "Diese Cookies erlauben es uns, Besuche und Verkehrsquellen zu zählen, damit wir die Leistung unserer Webseite messen und verbessern können. Sie helfen uns zu verstehen, welche Seiten am beliebtesten und am wenigsten beliebt sind, und zu sehen, wie sich Besucher auf der Webseite bewegen.",
    },
  ];

  return (
    <Layout className="min-h-screen bg-gray-100">
      <Content className="p-4 md:p-8 max-w-4xl mx-auto">
        <div className="bg-white shadow-md rounded-lg p-6 md:p-8">
          <Title level={2} className="text-center mb-6">
            Cookie-Erklärung
          </Title>
          <Paragraph className="mb-6">
            Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf
            unserer Website zu bieten. Im Folgenden erklären wir, welche Arten
            von Cookies wir verwenden und zu welchem Zweck.
          </Paragraph>

          <List
            itemLayout="vertical"
            dataSource={cookieTypes}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={<Title level={4}>{item.title}</Title>}
                  description={<Paragraph>{item.description}</Paragraph>}
                />
              </List.Item>
            )}
          />

          <Paragraph className="mt-6">
            Durch die weitere Nutzung unserer Website stimmen Sie der Verwendung
            von Cookies gemäß dieser Erklärung zu. Sie können Ihre
            Browser-Einstellungen ändern, um Cookies zu blockieren oder zu
            löschen, aber dies kann die Funktionalität unserer Website
            beeinträchtigen.
          </Paragraph>

          <Paragraph>
            Für weitere Informationen über unsere Verwendung von Cookies und
            Ihre Datenschutzrechte lesen Sie bitte unsere{" "}
            <a href="/privacypolicy" className="text-blue-600 hover:underline">
              Datenschutzerklärung
            </a>
            .
          </Paragraph>
        </div>
      </Content>
    </Layout>
  );
};

export default Cookies;
